/* eslint-disable react/prop-types */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material-ui
import { CrownOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Stack, Box, Chip, Tooltip, Typography, Button } from '@mui/material';

import Profile from 'layout/Dashboard/Header/HeaderContent/Profile';
import Badge from 'assets/images/badge.png';
import FullScreen from 'layout/Dashboard/Header/HeaderContent/FullScreen';
import useDemoMode from 'hooks/useDemoMode';

export default function HeaderContent(props) {
  const { demoMode } = useDemoMode();
  return (
    <Box sx={{ mb: 1, position: 'relative', zIndex: 20 }} display={'flex'} justifyContent={'end'} alignItems={'center'} gap={3}>
      {props.userType === 'is_premium' ? null :
        <Stack>
          <Button className="btn-upgrade" startIcon={<CrownOutlined />}>
            Upgrade to Tradatomy PRO
          </Button>
        </Stack>
      }
      <Stack>
        <Typography variant="h6" className="trader-status">
          <span className="status"></span>Live 11:00:00 AM
        </Typography>
      </Stack>
      <Box display={'flex'} justifyContent={'end'} alignItems={'center'} gap={1}>
        {demoMode && (
          <Tooltip title="Demo mode is active. Click to manage in Settings.">
            <Chip
              icon={<ExperimentOutlined style={{ color: '#8A5C00' }} />}
              label="DEMO"
              size="small"
              component={RouterLink}
              to="/account-settings"
              clickable
              sx={{
                bgcolor: '#FFF5CC',
                color: '#8A5C00',
                fontWeight: 700,
                letterSpacing: 0.5,
                border: '1px solid #E6C66B',
                '&:hover': { bgcolor: '#FFEB99' },
              }}
            />
          </Tooltip>
        )}
        <Stack alignItems="end" spacing={2}>
          <FullScreen />
        </Stack>
        <Stack alignItems="end" spacing={2}>
          <Profile compact />
        </Stack>
        <Stack alignItems="center" sx={{ fontSize: 10, textAlign: 'center' }}>
          <img src={Badge} alt="Points" />
          Today: Up 75 pts
        </Stack>
      </Box>
    </Box>
  );
}
